import React from "react"
import { useNavigate } from "react-router-dom"
import { useNativeVibration } from "@/hooks/useNativeVibration"

function PrevPageBtn() {
  const navigate = useNavigate()
  const vibrate = useNativeVibration()

  return (
    <button
      type="button"
      onClick={() => {
        vibrate("light")
        navigate(-1)
      }}
      className="
        w-9 h-9
        border
        border-white/20
        flex items-center justify-center
        rounded-[.7rem]
        opacity-80
        text-[var(--primary-color)]
        hover:text-[var(--primary-color)]
        transition-all
        active:scale-95
        backdrop-blur-xl
      "
    >
      <i className="bx bx-chevron-left text-2xl" />
    </button>
  )
}

export default PrevPageBtn